import _ from 'lodash';

export function getOldFormatCustomMetricsByChannel(newCustomMetrics, channel) {
  const oldCustomMetrics = [];
  for (const newCustomMetric of newCustomMetrics) {
    const detail = getDetailByChannel(newCustomMetric, channel);
    oldCustomMetrics.push({
      ..._.omit(newCustomMetric, 'details'),
      ..._.omit(detail, 'id'),
    });
  }
  return oldCustomMetrics;
}

function getDetailByChannel(newCustomMetric, channel) {
  const details = newCustomMetric.detailMap ? Array.from(newCustomMetric.detailMap.values()) : newCustomMetric.details;
  const existingChannelFilter = [];
  for (const detail of details) {
    if (!detail.condition) {
      if (existingChannelFilter.includes('else')) {
        throw new Error(`duplicated else :: ${newCustomMetric.name}`);
      }
      existingChannelFilter.push('else');
      continue;
    }

    const { condition } = detail;
    if (!Array.isArray(condition)) {
      throw new Error('condition should be array');
    }
    if (condition.length > 1 || condition.length === 0) {
      throw new Error('condition only support "channel". should have only one condition');
    }
    const conditionObj = condition[0];
    if (conditionObj.operator !== 'IN') {
      throw new Error('condition only support "channel". should be IN condition');
    }
    conditionObj.values.forEach(channel => {
      if (existingChannelFilter.includes(channel)) {
        throw new Error(`duplicated channel :: ${channel} :: ${newCustomMetric.name}`);
      }
      existingChannelFilter.push(channel);
    });
    if (conditionObj.values.includes(channel)) {
      return detail;
    }
  }
  const elseDetail = details.find(detail => detail.condition === null);
  return elseDetail;
}
